import { useLocation } from "react-router"
import { Redirect } from "lib/@components/redirect"

// The module has been renamed twice (Scenario Planner -> Cost Modeller -> Optimiser,
// FIQ-2130). Both legacy URL families still arrive from bookmarks and external links:
//   /app/scenario-planner/...            (entity segment was already "scenarios",
//                                         tab param was "scenarioPlannerTab")
//   /app/cost-modeller/cost-models/...   (entity segment "cost-models",
//                                         tab param "costModellerTab")
// Everything lands on /app/optimiser/scenarios/... with the "optimiserTab" param.
export function LegacyRouteRedirect() {
    const location = useLocation()
    const to = buildOptimiserRedirectPath(location)

    return <Redirect to={to} />
}

function buildOptimiserRedirectPath(location) {
    const pathname = location.pathname
        .replace(/^\/app\/scenario-planner/, "/app/optimiser")
        .replace(/^\/app\/cost-modeller/, "/app/optimiser")
        .replace(/^\/app\/optimiser\/cost-models(?=\/|$)/, "/app/optimiser/scenarios")
    const params = new URLSearchParams(location.search)

    for (const legacyParam of ["scenarioPlannerTab", "costModellerTab"]) {
        const legacyTab = params.get(legacyParam)
        if (legacyTab !== null) {
            params.delete(legacyParam)
            params.set("optimiserTab", normalizeTabValue(legacyTab))
        }
    }

    if (params.get("optimiserTab") === "cost-models") {
        params.set("optimiserTab", "scenarios")
    }

    const search = params.toString()
    return `${pathname}${search ? `?${search}` : ""}${location.hash}`
}

function normalizeTabValue(value) {
    if (value === "cost-models") return "scenarios"
    return value
}
